import { Form, Header } from 'semantic-ui-react';
import { Formik, FormikHelpers, FormikProps } from 'formik';
import './UserDetailsForm.less';

interface UserDetailsFields {
	firstName: string;
	lastName: string;
}

interface UserDetailsFormProps {
	onSubmit: (
		values: UserDetailsFields,
		actions: FormikHelpers<UserDetailsFields>
	) => void;
	renderActionButtons?: (isSubmitting: boolean) => React.ReactNode;
}

export const UserDetailsForm: React.FC<UserDetailsFormProps> = ({
	onSubmit,
	renderActionButtons,
}) => {
	return (
		<Formik
			onSubmit={onSubmit}
			initialValues={{
				firstName: '',
				lastName: '',
			}}
			validate={(values: UserDetailsFields) => {
				const errors: Partial<UserDetailsFields> = {};

				if (!/^[A-Za-z ]+$/.test(values.firstName)) {
					errors.firstName =
						'First name should only contain letters or spaces.';
				}

				if (!/^[A-Za-z ]+$/.test(values.lastName)) {
					errors.lastName = 'Last name should only contain letters or spaces.';
				}

				return errors;
			}}
		>
			{({
				values,
				errors,
				touched,
				handleChange,
				handleBlur,
				handleSubmit,
				isSubmitting,
			}: FormikProps<UserDetailsFields>) => (
				<Form className='user-details-form' onSubmit={handleSubmit}>
					<Header as='h3'>Tell us your name</Header>
					<p>
						Your name will be displayed with your goals and will be visible to
						other members in your organisation.
					</p>
					<div className='form-fields'>
						<div className='name-fields'>
							<Form.Input
								autoFocus
								fluid
								type='text'
								name='firstName'
								label='First Name'
								placeholder='First Name'
								onChange={handleChange}
								onBlur={handleBlur}
								value={values.firstName}
								error={!!(touched.firstName && errors.firstName)}
								required
							/>
							<Form.Input
								fluid
								type='text'
								name='lastName'
								label='Last Name'
								placeholder='Last Name'
								onChange={handleChange}
								onBlur={handleBlur}
								value={values.lastName}
								error={!!(touched.lastName && errors.lastName)}
								required
							/>
						</div>
					</div>
					{renderActionButtons && renderActionButtons(isSubmitting)}
				</Form>
			)}
		</Formik>
	);
};
